/* Torque free-shipping progress bar — live updater
   Recomputes on Dawn cart updates (drawer + cart page).
   No frameworks. Vanilla JS per Dawn conventions. */

(function () {
  'use strict';

  var THRESHOLD = 5000; // cents, $50.00. Must match snippet + Shopify shipping rate.

  function formatMoney(cents) {
    // Mirror Shopify money format. Symbol-only is fine for USD store.
    return '$' + (cents / 100).toFixed(2);
  }

  function updateBars(cartTotalCents) {
    var bars = document.querySelectorAll('[data-freeship-bar]');
    bars.forEach(function (bar) {
      var pct = Math.min(100, Math.round((cartTotalCents / THRESHOLD) * 100));
      var reached = cartTotalCents >= THRESHOLD;
      var remaining = Math.max(0, THRESHOLD - cartTotalCents);

      var fill = bar.querySelector('[data-freeship-fill]');
      var msg = bar.querySelector('[data-freeship-message]');
      var track = bar.querySelector('[role="progressbar"]');

      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', pct);

      if (reached) {
        bar.setAttribute('data-reached', 'true');
        if (msg) msg.textContent = 'Math checks out. Shipping’s on us';
      } else {
        bar.removeAttribute('data-reached');
        if (msg) {
          msg.innerHTML =
            '<span data-freeship-remaining>' +
            formatMoney(remaining) +
            '</span> more and shipping’s on us!';
        }
      }
    });
  }

  function fetchAndUpdate() {
    fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBars(cart.total_price); })
      .catch(function () { /* leave server-rendered state */ });
  }

  // Dawn publishes cart events via PUB_SUB_EVENTS. Subscribe if available.
  function init() {
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        fetchAndUpdate();
      });
    }
    // Fallback: Dawn cart drawer/items re-render swaps DOM. Watch for it.
    var cartRoot = document.querySelector('cart-drawer, cart-items');
    if (cartRoot && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { fetchAndUpdate(); });
      mo.observe(cartRoot, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();